export default () => ({
  posts: [],
  post: {},
});
